import { Icons } from 'assets/icons/icons.index';
import { Button } from 'components/atoms/Button/Button';
import { CardBody } from 'components/atoms/Card-body/Card-body';
import { Input } from 'components/atoms/Input/Input';
import { TagAlert } from 'components/atoms/Tag-alert/Tag-alert';
import { TagLabel } from 'components/atoms/Tag-label/Tag-label';
import { PeriodicityOptions } from 'models/periodicity.interface';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { getCouponByCode } from 'shared/services/coupons';
import { formatPrice } from 'utils/payments.utils';
import { isPromoActive, plansIsIncludes } from 'utils/pricing.utils';
import './Form-cupon.scss';
import { ICouponInformation } from './models/Form-cupon.interface';

export interface IPropsFormCoupon {
  orderId: string;
  onResetCuponInfo: () => void;
  value?: string;
  periodicity: string;
  branch: string;
  coupon?: ICouponInformation;
  onGetCoupon: (coupon: ICouponInformation) => void;
  marginSmall?: boolean;
  planIds: number[];
  templete: 'outline' | 'default';
}

export const FormCoupon = forwardRef(function FormCoupon(
  props: IPropsFormCoupon,
  ref
) {
  useImperativeHandle(ref, () => {
    return { validateCoupon };
  });
  const formCouponRef = useRef(null);
  const [couponValue, setCouponValue] = useState<string | undefined>(
    props.value
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [typeAlert, setTypeAlert] = useState<'success' | 'error'>('success');
  const [coupon, setCoupon] = useState<ICouponInformation | undefined | null>(
    props.coupon
  );
  useEffect(() => {
    if (props.coupon && props.planIds.length) {
      validateCoupon(props.planIds, props.coupon as ICouponInformation);
    }
  }, [props.coupon]);

  const setErrorToCoupon = () => {
    setTypeAlert('error');
    setCoupon(null);
  };
  const resetCouponInfo = () => {
    if (coupon?.is_read_only) {
      return;
    }
    
    setCouponValue('');
    setCoupon(undefined);
    props.onResetCuponInfo();
  };
  const getCoupon = async (plans?: number[], isOnlyCalculate = false) => {
    if (!couponValue) {
      return;
    }
    const planIds = plans ?? props.planIds;
    setIsLoading(true);
    try {
      const response = await getCouponByCode(
        (couponValue as string).toLocaleUpperCase()
      );
      if (response.data) {
        if (
          (response.data.attributes.is_anual &&
            props.periodicity === PeriodicityOptions.ANUAL &&
            plansIsIncludes(response.data.attributes, planIds)) ||
          (response.data.is_mensual &&
            props.periodicity === PeriodicityOptions.MENSUAL) ||
          plansIsIncludes(response.data.attributes, planIds)
        ) {
          setCoupon(response.data.attributes);
          if (!isOnlyCalculate) {
            props.onGetCoupon(response.data.attributes);
          }
          setTypeAlert('success');
          return response.data.attributes;
        } else {
          setErrorToCoupon();
        }
      } else {
        setErrorToCoupon();
      }
    } catch (error) {
      setErrorToCoupon();
    } finally {
      setIsLoading(false);
    }
  };
  const validateCoupon = (
    planIds: number[],
    coupon: ICouponInformation,
    isOnlyCalculate = false
  ) => {
    if (!couponValue) {
      return;
    }
    try {
      if (
        (coupon.is_anual &&
          props.periodicity === PeriodicityOptions.ANUAL &&
          plansIsIncludes(coupon, planIds)) ||
        (coupon.is_mensual &&
          props.periodicity === PeriodicityOptions.MENSUAL) ||
        plansIsIncludes(coupon, planIds)
      ) {
        setCoupon(coupon);
        if (!isOnlyCalculate) {
          props.onGetCoupon(coupon);
        }

        setTypeAlert('success');
        return coupon;
      } else {
        setErrorToCoupon();
      }
    } catch (error) {
      setErrorToCoupon();
    }
  };
  return (
    <CardBody templete={props.templete}>
      <div
        className={`form__coupon__container ${
          props.marginSmall ? 'margin--small' : ''
        }`}
        ref={formCouponRef}
      >
        <div className="form__coupon__title">
          <h5>¿Tienes un cupón?</h5>
        </div>
        <div className="form__coupon__content">
          <Input
            label="Agregar Cupón"
            id="form__coupon__content__input"
            type="alphanumeric"
            name="coupon"
            onChange={(e) => setCouponValue(e.target.value)}
            value={couponValue || ''}
            placeholder=""
            isTouched={false}
            errorInput={''}
            isRequired={false}
            isDisabled={coupon?.is_read_only}
            WrapperClassName="w-70"
          />
          <Button
            className="button__coupon"
            size="medium"
            template="primary"
            color="secondary"
            typeStyle="square"
            type="button"
            isDisabled={!couponValue || coupon?.is_read_only}
            onClick={() => getCoupon()}
            isLoading={isLoading}
          >
            Aplicar
          </Button>
        </div>
        {((couponValue && coupon === null) ||
          (couponValue && coupon?.coupon_code)) && (
          <div className="form__coupon__info__container">
            <TagAlert type={typeAlert} size="medium" typeStyle="square">
              Cupón <strong>{couponValue.toLocaleUpperCase()}</strong>{' '}
              {typeAlert === 'error' ? 'no válido' : 'aplicado'}
            </TagAlert>
            {coupon && coupon.amount !== undefined && (
              <TagLabel
                type="secondary"
                typeStyle="square"
                onClick={!coupon.is_read_only ? resetCouponInfo : undefined}
              >
                <img src={Icons.iconTag} alt="icono tag" />
                <div className="tag__label__info__coupon">
                  <span className="tag__label__info__coupon--bold">
                    {couponValue?.toLocaleUpperCase()}
                  </span>
                  {!isPromoActive && (
                    <span>
                      {coupon.is_percent
                        ? `${coupon.amount}% dcto.`
                        : `-$${formatPrice(coupon.amount, props.branch)}`}{' '}
                    </span>
                  )}
                </div>
              </TagLabel>
            )}
          </div>
        )}
      </div>
    </CardBody>
  );
});
